import { logout } from "./authService";

const API_BASE =
  (process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.replace(/\/$/, '')) ||
  (process.env.NODE_ENV === 'production'
    ? 'https://buzzly-api.qsstechnosoft.com/api'
    : 'http://localhost:5000/api');

export const API_BASE_URL = API_BASE;

const baseHeaders = { 'Content-Type': 'application/json' };
const readToken = () => {
  const t = localStorage.getItem('token');     // could be "null"/"undefined"
  if (!t || t === 'null' || t === 'undefined') return null;
  return t.trim();
};
const makeHeaders = () => {
  const headers = { ...baseHeaders };
  const token = readToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const userStr = localStorage.getItem('user');
  if (userStr) {
    headers['X-User-Data'] = userStr;
    try {
      const u = JSON.parse(userStr);
      if (u?.id) headers['X-User-Id'] = String(u.id);
    } catch {}
  }
  return headers;
};

const makeFileHeaders = () => {
    const headers = {}; // Start with an empty object
    const token = readToken();
    if (token) headers.Authorization = `Bearer ${token}`;
    // ... (add other headers like X-User-Data if needed)
    return headers;
};



const doFetch = async (method, endpoint, body) => {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method,
    headers: makeHeaders(),
    body: body ? JSON.stringify(body) : undefined,
    // credentials: 'include', // uncomment if you switch to cookie sessions
  });

  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { message: text };
  }

    // 👇 yahan token expire check
 if (res.status === 401 || res.status === 403) {
    const detail = (data?.message || data?.error || data?.details || '').toLowerCase();
    if (detail.includes('jwt') || detail.includes('token') || detail.includes('invalid')) {
      console.warn("⚠️ JWT expired/invalid. Logging out...");
      logout();
    } else {
      console.warn("⚠️ Auth error:", data?.message || data?.error);
    }
    return;
  }

  if (!res.ok) throw new Error(data?.message || `API error (${res.status})`);
  return data;
};

const doFetchFile = async (endpoint, formData) => {
    const res = await fetch(`${API_BASE}${endpoint}`, {
        method: 'POST',
        headers: makeFileHeaders(), // Use the new header function
        body: formData, // Pass formData directly, WITHOUT JSON.stringify
    });
    const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { message: text };
  }

    // 👇 yahan token expire check
  if (res.status === 401 || res.status === 403) {
    const detail = (data?.message || data?.error || data?.details || '').toLowerCase();
    if (detail.includes('jwt') || detail.includes('token') || detail.includes('invalid')) {
      console.warn("⚠️ JWT expired/invalid. Logging out...");
      logout();
    } else {
      console.warn("⚠️ Auth error:", data?.message || data?.error);
    }
    return;
  }

  if (!res.ok) throw new Error(data?.message || `API error (${res.status})`);
  return data;



  }
  export const apiPostFile = (endpoint, formData) => doFetchFile(endpoint, formData);
export const apiGet    = (endpoint)        => doFetch('GET', endpoint);
export const apiPost   = (endpoint, data)  => doFetch('POST', endpoint, data);
export const apiPut    = (endpoint, data)  => doFetch('PUT', endpoint, data);
export const apiDelete = (endpoint)        => doFetch('DELETE', endpoint);
